import { useRef } from 'react';

// The handle and title whitespace own this gesture. Header controls and body
// scrolling remain native; closing uses the same draft guard as the X button.
export default function useSheetHandle({ enabled, onClose, root }) {
  const drag = useRef(null);
  const reset = () => {
    drag.current = null;
    root.current?.style.removeProperty('--sheet-handle-drag');
  };
  return {
    onPointerDown: (e) => {
      if (!enabled || e.isPrimary === false || e.button !== 0) return;
      const control = e.target.closest?.('button, a, input, textarea, [role="slider"]');
      if (control && control !== e.currentTarget) return;
      drag.current = { id: e.pointerId, x: e.clientX, y: e.clientY, dy: 0 };
      e.currentTarget.setPointerCapture?.(e.pointerId);
      e.preventDefault();
    },
    onPointerMove: (e) => {
      const start = drag.current;
      if (!start || start.id !== e.pointerId) return;
      const dy = Math.max(0, e.clientY - start.y);
      if (Math.abs(e.clientX - start.x) > Math.max(24, dy)) {
        reset();
        return;
      }
      start.dy = dy;
      root.current?.style.setProperty('--sheet-handle-drag', `0 ${Math.min(140, dy)}px`);
    },
    onPointerUp: (e) => {
      const start = drag.current;
      if (!start || start.id !== e.pointerId) return;
      const close = start.dy >= 72;
      const committed = close && enabled && onClose() === true;
      drag.current = null;
      if (!committed) root.current?.style.removeProperty('--sheet-handle-drag');
      e.currentTarget.releasePointerCapture?.(e.pointerId);
    },
    onPointerCancel: reset,
    onLostPointerCapture: () => {
      if (drag.current) reset();
    },
  };
}
